import { render, staticRenderFns } from "./PrintVetTest.vue?vue&type=template&id=3275f6ab&scoped=true"
import script from "./PrintVetTest.vue?vue&type=script&lang=js"
export * from "./PrintVetTest.vue?vue&type=script&lang=js"
import style0 from "./PrintVetTest.vue?vue&type=style&index=0&id=3275f6ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275f6ab",
  null
  
)

export default component.exports